import React from 'react'
import MetaTags from 'components/MetaTags'

import Layout from 'layouts/Layout'

import Compare from 'components/buy/epod2/Compare'
import Why from 'components/buy/epod2/Why'
import Products from 'components/buy/epod2/Products'
import Hero from 'components/buy/epod2/Hero'

export default () => (
  <Layout hideHeader>
    <MetaTags title="ePod 2 | Vuse CA" />
    <div
      css={`
        background-color: #1f1f1f;
      `}
    >
      <Hero />
      <Products />
      <Why />
      <Compare />
    </div>
  </Layout>
)
